mutation postToSocialMediaForCompanies($input: PostToSocialMediaMultiCompanyInput!) {
  result: postToSocialMediaForCompanies(input: $input) {
    savedContentId
    postingOperationId
    scheduledAt
    targetOverview {
      companyId
      resolvedUrl
      accounts {
        platform
        accountId
        displayName
      }
      platforms
    }
    posts {
      hasFailed
      type
      permalink
      externalPostId
    }
  }
}
